import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import cn from 'classnames';
import { getTime } from '../utils';
import { views } from '../../../constants/views';
import { modes } from '../../../constants/modes';
import { useCalendarState } from '../../../context/CalendarContext';
import styles from '../CalendarGrid.module.scss';

const SideColumn = ({ rowCount }) => {
  const { view, mode, calendarSheet, localTask } = useCalendarState();

  const scrollToElRef = useRef();

  useEffect(() => {
    if (
      scrollToElRef.current &&
      view !== views.month &&
      mode !== modes.agenda &&
      !localTask
    ) {
      window.scrollTo({
        top: scrollToElRef.current.offsetTop,
        behavior: 'smooth',
      });
    }
  }, [scrollToElRef.current, view, mode, localTask]);

  const getCellContent = (index) => {
    if (mode === modes.agenda) {
      const currentDay = calendarSheet.clone().startOf(view).add(index, 'day');

      return (
        <p
          className={cn(styles.time, styles.agendaTime, styles.sticky, {
            [styles.currentDay]: moment().isSame(currentDay, 'day'),
          })}
        >
          {currentDay.format('D MMMM, ddd')}
        </p>
      );
    } else {
      return view === views.day || view === views.week ? (
        <p
          className={cn(styles.time, styles.dayHour)}
          style={
            view !== views.month && index === 0
              ? { transform: 'translate(-50%, 0)' }
              : {}
          }
        >
          {getTime(index)}
        </p>
      ) : null;
    }
  };

  return Array.from(Array(rowCount)).map((_, index) => {
    const startCount = mode === modes.agenda ? 1 : view === views.month ? 2 : 3;
    const endCount = mode === modes.agenda ? 2 : view === views.month ? 3 : 4;

    return (
      <div
        ref={getTime(index) === '08:00' ? scrollToElRef : undefined}
        key={index}
        className={cn(styles.sideCellWrapper, {
          [styles.borderBottom]: index !== rowCount - 1,
        })}
        style={{
          gridColumn: '1/2',
          gridRow: `${index + startCount}/${index + endCount}`,
        }}
      >
        {getCellContent(index)}
      </div>
    );
  });
};

export default SideColumn;
